var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"process-bar-container"},[_c('div',{staticClass:"process-bar",style:({ width: `${_vm.percent}%` })})])
}
var staticRenderFns = []

export { render, staticRenderFns }